import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { TouchableOpacity } from 'react-native';
import { useDispatch } from 'react-redux';

import { useSafeParams } from 'components/Routes/useSafeParams';
import { Link, useHistory } from 'cross-platform/react-router';
import { isDevMode } from 'lib/isDevMode';
import { showQAMenu } from 'lib/showQAMenu';

export const LogoButton = ({
  children,
}: {
  children: ReactNode;
}): ReactElement => {
  const { productReference } = useSafeParams();
  const history = useHistory();
  const dispatch = useDispatch();

  return isDevMode() ? (
    <TouchableOpacity
      onPress={() => showQAMenu(productReference, history, dispatch)}
    >
      {children}
    </TouchableOpacity>
  ) : (
    <Link to={`/${productReference}/home`} title={'Home'}>
      {children}
    </Link>
  );
};
